import { Component, Input, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import {
    ChartComponent,
    ApexNonAxisChartSeries,
    ApexResponsive,
    ApexChart,
    ApexTitleSubtitle,
    ApexFill,
    ApexStroke,
    ApexYAxis,
    ApexLegend,
    ApexPlotOptions,
    NgApexchartsModule,
    ApexTooltip,
} from 'ng-apexcharts';

export type ChartOptions = {
    series: ApexNonAxisChartSeries;
    chart: ApexChart;
    responsive: ApexResponsive[];
    labels: any;
    title: ApexTitleSubtitle;
    fill: ApexFill;
    tooltip: ApexTooltip;
    yaxis: ApexYAxis;
    stroke: ApexStroke;
    legend: ApexLegend;
    colors: string[];
    plotOptions: ApexPlotOptions;
};

@Component({
    selector: 'app-customer-satisfaction',
    standalone: true,
    imports: [
        MatCardModule,
        MatMenuModule,
        MatButtonModule,
        NgApexchartsModule,
    ],
    templateUrl: './customer-satisfaction.component.html',
    styleUrl: './customer-satisfaction.component.scss',
})
export class CustomerSatisfactionComponent {
    @ViewChild('chart') chart: ChartComponent;
    public chartOptions: Partial<ChartOptions>;

    @Input() data: any = {
        name: '',
        labels: [],
        series: [],
        colors: [],
    };

    constructor() {
        this.chartOptions = {
            series: this.data.series,
            chart: {
                height: 400,
                type: 'donut',
                toolbar: {
                    show: true
                }
            },
            labels: this.data.labels,
            fill: {
                opacity: 1,
            },
            stroke: {
                width: 1,
                colors: undefined,
            },
            colors: ['#00FF00', '#FFFF00', '#FFA500', '#FF0000'],
            yaxis: {
                show: false,
            },
            legend: {
                offsetY: -10,
                fontSize: '14px',
                position: 'bottom',
                horizontalAlign: 'center',
                labels: {
                    colors: '#919aa3',
                },
                itemMargin: {
                    horizontal: 12,
                    vertical: 7,
                },
                formatter: function(seriesName, opts) {
                    return seriesName + " - " + opts.w.globals.series[opts.seriesIndex]
                }
            },
            plotOptions: {
                pie: {
                    donut: {
                        labels: {
                            show: true,
                            name: {
                                show: true,
                            },
                            value: {
                                show: true,
                            },
                            total: {
                                show: true,
                                showAlways: true,
                            },
                        },
                    },
                },
            },
            tooltip: {
                y: {
                    formatter: function (val) {
                        return val + '';
                    },
                },
            },
        };
    }

    // changeData
    changeData() {
        this.chartOptions.series = this.data.series;
        this.chartOptions.labels = this.data.labels;
        this.chartOptions.colors = this.data.colors;
    }
}
